import Vue from 'vue'
import App from './App.vue'
import router from './router'
import maskDirective from './directives/mask'

Vue.directive('mask', maskDirective)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

